import React, { useState, useEffect, useMemo, useCallback } from 'react'
import { useParams, useHistory } from 'react-router-dom'
import { useQuery, useMutation } from '@apollo/client'
import { useForm, FormProvider } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as Yup from 'yup'
import {
  GET_ONE_JURISDICTION_SUB,
  CREATE_SUB_JURISDICTIONS,
  UPDATE_SUB_JURISDICTIONS,
  GET_ALL_JURISDICTION_SUBS,
} from '../../../../graphql/Catalog/Jurisdictions/jurisdictionSub'
import { toastSweetAlert } from '../../../Helpers/ToastSweetAlert'
import Box from '../../../Global/Box'
import ContentHeader from '../../../Layout/ContentHeader'
import InputController from '../../../Global/InputController'
import { useLoading } from '../../../../LoadingOverlay/LoadingOverlayContext'
import MapTS from './components/MapTS'
const API_KEY = process.env.REACT_APP_API_KEY_GOOGLE_MAPS

const ZonesNew = () => {
  const { id: _id } = useParams()
  const history = useHistory()
  const [loading, setLoading] = useState(false)
  const { showLoading, hideLoading } = useLoading()
  const [mapCenter, setMapCenter] = useState({ lat: 0, lng: 0 })
  const [users, setUsers] = useState([])
  const [geofence, setGeofence] = useState(null)

  const validationSchema = Yup.object().shape({
    name: Yup.string().required('Campo requerido'),
  })

  const methods = useForm({ resolver: yupResolver(validationSchema) })
  const {
    handleSubmit,
    control,
    formState: { errors },
    reset,
    watch,
    setValue,
    getValues,
  } = methods

  const {
    data: dataJurisdiction,
    loading: loadingJurisdiction,
    refetch,
  } = useQuery(GET_ONE_JURISDICTION_SUB, {
    variables: { getOneJurisdictionSubId: parseInt(_id) },
    skip: !_id,
  })

  const [createJurisdictionSub] = useMutation(CREATE_SUB_JURISDICTIONS, {
    refetchQueries: [
      {
        query: GET_ALL_JURISDICTION_SUBS,
        variables: {
          searchQuery: null,
          limit: 10,
          offset: 0,
        },
        fetchPolicy: 'no-cache',
      },
    ],
  })
  const [updateJurisdictionSub] = useMutation(UPDATE_SUB_JURISDICTIONS, {
    refetchQueries: [
      {
        query: GET_ALL_JURISDICTION_SUBS,
        variables: {
          searchQuery: null,
          limit: 10,
          offset: 0,
        },
        fetchPolicy: 'no-cache',
      },
    ],
  })

  useEffect(() => {
    setLoading(true)
    showLoading()
    if (_id && dataJurisdiction) {
      const jurisdiction = dataJurisdiction.getOneJurisdictionSub
      const formattedData = {
        name: jurisdiction.name,
      }
      reset(formattedData)
      setUsers(jurisdiction.JurisdictionsSubToUser || [])
      setGeofence(jurisdiction.geofence)
    }
    setLoading(false)
    hideLoading()
  }, [dataJurisdiction, _id, reset, showLoading, hideLoading])

  const onSubmit = useCallback(
    async (data) => {
      // if(!geofence) 
      //   return toastSweetAlert({ mode: 'error', message: 'Geofence es requerido' })

      // const geofenceObject = JSON.parse(geofence)
      // if (!geofenceObject.points || geofenceObject.points.length === 0) {
      //   toastSweetAlert({ mode: 'error', message: 'Geofence debe tener al menos un punto' })
      //   return
      // }

      setLoading(true)
      showLoading()
      try {
        if (_id) {
          await updateJurisdictionSub({
            variables: {
              subsOfJurisdiction: {
                id: parseInt(_id),
                name: data.name,
                // geofence: geofence,
              },
            },
          })
          toastSweetAlert({
            mode: 'ok',
            message: 'Zona actualizada exitosamente',
          })
        } else {
          await createJurisdictionSub({
            variables: {
              inputSubJurisdictions: {
                name: data.name,
                // geofence: geofence,
              },
            },
          })
          toastSweetAlert({
            mode: 'ok',
            message: 'Zona creada exitosamente',
          })
        }
        reset()
        refetch()
        history.push('/zones')
      } catch (error) {
        toastSweetAlert({ mode: 'error', message: error.message })
      } finally {
        setLoading(false)
        hideLoading()
      }
    },
    [
      _id,
      createJurisdictionSub,
      updateJurisdictionSub,
      reset,
      refetch,
      history,
      showLoading,
      hideLoading,
      geofence,
    ]
  )

  const handleCompleteGeofence = (geofenceParam) => {
    if (geofenceParam.points.length == 0) {
      toastSweetAlert({ mode: 'error', message: 'Geofence debe tener al menos 1 punto' })
      return
    }
    setGeofence(JSON.stringify(geofenceParam))
  }

  const handleCleanGeofence = () => {
    setGeofence(null)
  }

  return (
    <>
      <ContentHeader
        title="Gestión de zonas"
        breadcrumb="Zonas"
        windowTitle={`${_id ? 'Editar' : 'Agregar'} zona`}
      />
      <FormProvider {...methods}>
        <form className="px-2 pb-3" onSubmit={handleSubmit(onSubmit)}>
          <Box
            title={`${_id ? 'Editar' : 'Agregar'} zona`}
            btnRedPath="/zones"
            btnRedTxt="Cancelar"
            btnSubmit={true}
            btnState={loading}
            errors={errors}
            content={
              <>
                <div className="row">
                  <div className="mb-3 col-12">
                    <InputController
                      label="Nombre"
                      type="text"
                      name="name"
                      placeholder="Nombre de la zona"
                      control={control}
                    />
                  </div>
                  {/* <div className="mb-3 col-12">
                    <MapTS 
                      mapCenter={mapCenter} 
                      handleComplete={handleCompleteGeofence} 
                      handleClean={handleCleanGeofence}
                      googleMapsApiKey={API_KEY} 
                      initialShape={geofence? JSON.parse(geofence): null}
                    />
                  </div> */}
                </div>
              </>
            }
          />
        </form>
      </FormProvider>
      {/* {_id && <UsersList users={users} />} */}
    </>
  )
}

const UsersList = ({ users }) => {
  return (
    <div className="ml-3 mt-4 pb-4">
      <h3>Usuarios Responsables</h3>
      <ul>
        {users.length === 0 ? (
          <li>No hay usuarios asignados</li>
        ) : (
          <>
            {users.map((user) => (
              <li className="mt-1 mb-1" key={user.id}>
                {user.first_name} {user.last_name} - {user.email} - {user.phone}
              </li>
            ))}
          </>
        )}
      </ul>
    </div>
  )
}

export default ZonesNew
